import { Container } from "@mui/material";
import TopBar from "./TopBar";
import { ConversionListViewer } from "../general";
import { useResetDashboardSettings } from "../../../hooks";

const Dashboard = () => {
  const reset = useResetDashboardSettings();

  const {
    executeSettingsReset,
    settingsResetExecuted,
    showResetIcon,
    setShowResetIcon,
    resetSettingsHandle,
  } = reset;

  return (
    <Container sx={{ minHeight: "550px", mb: 10, mt: 3 }}>
      <ConversionListViewer
        reset={{
          executeSettingsReset,
          settingsResetExecuted,
          setShowResetIcon,
        }}
        settingsTopBar={
          <TopBar
            reset={{
              showResetIcon,
              resetSettingsHandle,
            }}
          />
        }
      />
    </Container>
  );
};

export default Dashboard;